import React from 'react';
import { Script } from 'gatsby'
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */

import 'utils/styles/global.scss';
import 'utils/styles/tricks.scss';

import { QueryClient, QueryClientProvider } from 'react-query';

import SideBarContextProvider from 'context/sidebarContextWrapper';
import SearchContextProvider from 'context/searchContextWrapper';
import NotificationContextProvider from 'context/notificationContextWrapper'

import { 
  isVisible, 
  showDefault,
  headLine,
  bannerLink,
  bannerProduct, 
  bannerProductHeadline, 
  bannerProductLink 
} from 'config/announcement';
import AnnouncementBanner from 'components/AnnouncementBanner/AnnouncementBanner.component';



export const wrapRootElement = ({ element }) => {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
        <SideBarContextProvider>
          <SearchContextProvider>
            <NotificationContextProvider>
              {element}
            </NotificationContextProvider>
          </SearchContextProvider>
        </SideBarContextProvider>
    </QueryClientProvider>
  );
};


export const wrapPageElement = ({ element, props }) => {
  const product = props.path?.split('/')[1] || 'fusion'
  const matchedProduct = product === bannerProduct
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to main content</a>
      { isVisible && showDefault && !matchedProduct ? <AnnouncementBanner headLine={headLine} bannerLink={bannerLink} /> : null}
      { isVisible && matchedProduct ? <AnnouncementBanner headLine={bannerProductHeadline} bannerLink={bannerProductLink} /> : null}
      { element }
      <Script
        key='userback-1'
        src='https://static.userback.io/widget/v1.js'
        strategy="idle"
      />

      <Script 
        key='userback-2'
        strategy="idle"
      >
        {`
            window.Userback = window.Userback || {};
            window.Userback.access_token = "${process.env.GATSBY_USERBACK_TOKEN_2}"
        `}
      </Script>
    </>
  )
}
